import { useState } from "react";
import { ExternalLink, Loader2, RefreshCw } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "../../lib/api";
import { fmtDate } from "./shared";

const STATE_STYLE = {
  ready: "bg-[#138808]/10 text-[#0f6d06]",
  in_research: "bg-[#FF9933]/15 text-[#a35400]",
  awaiting_research: "bg-neutral-100 text-neutral-600",
};

export const MatchPanel = ({ lead, onChanged }) => {
  const mm = lead.matchmaking;
  const [busy, setBusy] = useState("");
  if (!mm) return null;

  const act = async (kind) => {
    setBusy(kind);
    try {
      await api.post(`/staff/leads/${lead.id}/matchmaking/${kind}`);
      toast.success("MatchMaking status updated");
      onChanged();
    } catch (e) {
      toast.error(formatApiError(e));
    }
    setBusy("");
  };

  return (
    <div className="mt-6 rounded-2xl border border-[#138808]/30 p-4" data-testid="lead-matchmaking-panel">
      <div className="flex items-center justify-between gap-2">
        <p className="text-xs font-semibold uppercase tracking-[0.14em] text-[#0f6d06]">MatchMaking cart · {mm.projects.length}</p>
        <button onClick={() => act("refresh")} disabled={!!busy} className="flex min-h-[36px] items-center gap-1.5 text-xs font-semibold text-neutral-600" data-testid="lead-matchmaking-refresh-button">
          {busy === "refresh" ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <RefreshCw className="h-3.5 w-3.5" />} Refresh
        </button>
      </div>
      <p className="mt-1 text-xs text-neutral-500" data-testid="lead-matchmaking-state">
        {mm.state === "select_failed" ? "Not sent to MatchMaking yet — press Refresh to retry" : `Request ${mm.state?.replace(/_/g, " ")}`}
        {mm.promised_by ? ` · promised by ${fmtDate(mm.promised_by)}` : ""}
        {mm.emailed_at ? ` · emailed ${fmtDate(mm.emailed_at)}` : ""}
        {mm.whatsapp_at ? ` · WhatsApp opened ${fmtDate(mm.whatsapp_at)}` : ""}
      </p>
      <ul className="mt-3 space-y-2">
        {mm.projects.map((p) => (
          <li key={p.ref} className="rounded-xl bg-[#fbf8f3] p-3 text-sm" data-testid={`lead-mm-item-${p.ref}`}>
            <div className="flex items-start justify-between gap-2">
              <div>
                <p className="font-semibold text-[#1f2328]">{p.name}</p>
                <p className="text-xs text-neutral-500">{[p.developer, p.locality, p.bhk, p.price].filter(Boolean).join(" · ")} · {p.match_pct}%</p>
              </div>
              <span className={`shrink-0 rounded-full px-2 py-0.5 text-[11px] font-semibold ${STATE_STYLE[p.state] || STATE_STYLE.awaiting_research}`}>{(p.state || "pending").replace(/_/g, " ")}</span>
            </div>
            <div className="mt-1.5 flex gap-3 text-xs">
              {p.matchmaking_url && <a href={p.matchmaking_url} target="_blank" rel="noopener noreferrer" className="flex items-center gap-1 font-semibold text-[#138808]">MatchMaking <ExternalLink className="h-3 w-3" /></a>}
              {p.source_url && <a href={p.source_url} target="_blank" rel="noopener noreferrer" className="flex items-center gap-1 text-neutral-500">Listing <ExternalLink className="h-3 w-3" /></a>}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};
